import React from 'react';
import './App.css';
import Bookings from './components/Bookings';
import Navbar from './components/Navbar';
import 'react-tooltip/dist/react-tooltip.css'

function App() {
  return (
    <div className="App">
        <Navbar />
        <Bookings />
    </div>
  );
}

export default App;
